module.exports = __webpack_public_path__ + "img/character.be747a5d.png";